import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import { formatDateTime } from "../opportunities/OpportunitiesTable";

const InfoField = ({ label, value }) => {
  const isDash = value === "-";
  return (
    <Box
      sx={{
        mb: 2,
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
      }}
    >
      <Typography
        sx={{
          color: "#6B7280",
          fontSize: "12px",
          fontWeight: 600,
          textTransform: "uppercase",
          letterSpacing: "0.05em",
          mb: 0.5,
          textAlign: isDash ? "center" : "left",
        }}
      >
        {label}
      </Typography>
      <Typography
        sx={{
          color: "#111827",
          fontSize: "15px",
          fontWeight: 600,
          wordBreak: "break-all",
          textAlign: isDash ? "center" : "left",
        }}
      >
        {value || "N/A"}
      </Typography>
    </Box>
  );
};

InfoField.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.node,
};

const AscellaTracking = ({ order }) => {
  const shippingDateRaw =
    order.shippingDate || order.shippingInfo?.shippingDate;
  const formattedShippingDate = shippingDateRaw
    ? formatDateTime(shippingDateRaw, true)
    : "-";

  return (
    <Box
      sx={{
        backgroundColor: "#F9FAFB",
        p: 3,
        borderRadius: "20px",
        mb: 2,
        border: "1px solid #F3F4F6",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 2,
        }}
      >
        <Box sx={{ width: "calc(33.33% - 16px)" }}>
          <InfoField label="Member Name" value={order.memberName} />
        </Box>
        <Box sx={{ width: "calc(33.33% - 16px)" }}>
          <InfoField
            label="Vendor"
            value={order.vendor ? String(order.vendor).toUpperCase() : "N/A"}
          />
        </Box>
        <Box sx={{ width: "calc(33.33% - 16px)" }}>
          <InfoField
            label="Submitted on"
            value={formatDateTime(order.submittedOn, true)}
          />
        </Box>
        <Box sx={{ width: "calc(33.33% - 16px)" }}>
          <InfoField label="Shipping Status" value={order.stageName || "-"} />
        </Box>
        <Box sx={{ width: "calc(33.33% - 16px)" }}>
          <InfoField
            label="Shipping Courier"
            value={
              order.carrierName || order.shippingInfo?.shippingCourier || "-"
            }
          />
        </Box>
        <Box sx={{ width: "calc(33.33% - 16px)" }}>
          <InfoField
            label="Tracking Number"
            value={
              order.trackingId || order.shippingInfo?.trackingNumber || "-"
            }
          />
        </Box>
        <Box sx={{ width: "calc(33.33% - 16px)" }}>
          <InfoField label="Shipping Date" value={formattedShippingDate} />
        </Box>
      </Box>
    </Box>
  );
};

AscellaTracking.propTypes = {
  order: PropTypes.shape({
    orderId: PropTypes.string,
    trackingId: PropTypes.string,
    enrollmentId: PropTypes.string,
    memberName: PropTypes.string,
    vendor: PropTypes.string,
    submittedOn: PropTypes.string,
    status: PropTypes.string,
    carrierName: PropTypes.string,
    shippingDate: PropTypes.string,
    shippingInfo: PropTypes.shape({
      shippingCourier: PropTypes.string,
      trackingNumber: PropTypes.string,
      shippingDate: PropTypes.string,
    }),
  }).isRequired,
};

export default AscellaTracking;
